import { Text } from '@/components'

export type RewardRowProps = {
  onClick?: () => void
  icon: JSX.Element
  label: string
  label2: JSX.Element
  description: string
}

export const RewardRow = ({ ...props }: RewardRowProps) => {
  const { icon, label, label2, description, onClick } = props

  return (
    <div
      className="w-full flex flex-row items-start justify-between py-6"
      onClick={onClick}
    >
      {icon}
      <div className="flex flex-col grow items-start px-4 gap-1">
        <Text className="text-sm font-semibold text-gray-900">{label}</Text>
        <Text className="text-sm font-normal text-gray-500">{description}</Text>
      </div>
      {label2}
    </div>
  )
}
